var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.8 18.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#999;stroke-miterlimit:10;stroke-width:.8px;}.cls-2,.cls-3{fill:#fff;}.cls-4{fill:#999;}.cls-4,.cls-3{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.4,
    y: 0.4,
    width: 18,
    height: 18,
    rx: 2.1,
    ry: 2.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.6,6.9h-6.9c-.2,0-.3-.1-.3-.3s.1-.3,.3-.3h6.9c.2,0,.3,.1,.3,.3s-.1,.3-.3,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.6,5h-6.9c-.2,0-.3-.1-.3-.3s.1-.3,.3-.3h6.9c.2,0,.3,.1,.3,.3s-.1,.3-.3,.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.3,6.6c.1,.2,.1,.5,0,.7s-.4,.4-.6,.4H3.6c-.3,0-.5-.1-.6-.4-.1-.2-.1-.5,0-.7l1.6-2.7c.1-.2,.4-.4,.6-.4s.5,.1,.6,.4l1.6,2.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.2,
    cy: 6.7,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.9,5.9c0,.2,.1,.3,.3,.3s.3-.1,.3-.3v-.9c0-.2-.1-.3-.3-.3s-.3,.1-.3,.3v.9Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.6,13.9h-6.9c-.2,0-.3-.1-.3-.3s.1-.3,.3-.3h6.9c.2,0,.3,.1,.3,.3s-.1,.3-.3,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.6,12h-6.9c-.2,0-.3-.1-.3-.3s.1-.3,.3-.3h6.9c.2,0,.3,.1,.3,.3s-.1,.3-.3,.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.3,13.6c.1,.2,.1,.5,0,.7s-.4,.4-.6,.4H3.6c-.3,0-.5-.1-.6-.4-.1-.2-.1-.5,0-.7l1.6-2.7c.1-.2,.4-.4,.6-.4s.5,.1,.6,.4l1.6,2.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.2,
    cy: 13.7,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.9,12.9c0,.2,.1,.3,.3,.3s.3-.1,.3-.3v-.9c0-.2-.1-.3-.3-.3s-.3,.1-.3,.3v.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertList);
export default __webpack_public_path__ + "static/media/alert-list.4cc8fdf335943e0cc6aaeaef517836ef.svg";
export { ForwardRef as ReactComponent };